import React, { FC } from 'react';
import { Trans } from 'react-i18next';

import successIcon from 'src/front/assets/icon_success.svg';
import { BREAK_POINTS } from 'src/front/constant';
import styled from 'styled-components';

interface Props {
  isSuccess: boolean;
  label: string;
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const SuccessIcon = styled.img`
  position: absolute;
  left: 30px;

  width: 20px;
  height: 20px;

  @media only screen and (max-width: ${BREAK_POINTS.MAX.LARGE_1X}) {
    left: 15px;
  }
`;

const Label = styled.div`
  margin-left: 5px;
`;

const SuccessButtonText: FC<Props> = ({ isSuccess, label }) => (
  <Row>
    {isSuccess ? <SuccessIcon alt={label} src={successIcon} /> : null}
    <Row>
      {isSuccess ? <Trans i18nKey="general_retryDownload_button" /> : null}
      <Label>
        <Trans i18nKey={label} />
      </Label>
    </Row>
  </Row>
);

export default SuccessButtonText;
